// @flow
import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

import { GeneralModalForm } from "imagus-components";
import UpdateProductPartForm from "../../containers/quotes/UpdateProductPartForm";

type ProductSheetPartItemPropsType = {
  item: { [key: string]: * },
  canEdit?: boolean
};

type ProductSheetPartItemStatesType = {
  modalOpen: boolean
};

class ProductSheetPartItem extends Component<
  ProductSheetPartItemPropsType,
  ProductSheetPartItemStatesType
> {
  constructor(props: ProductSheetPartItemPropsType) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  render(): React$Element<*> {
    let item = this.props.item;
    return (
      <TableRow>
        <TableCell padding="dense">{item.licenceType}</TableCell>
        <TableCell padding="dense">{item.partno}</TableCell>
        <TableCell padding="dense">
          {"$" + item.price}
          {item.hasRange &&
            item.priceRanges.map(
              (range: *, i: number): * => (
                <div className="inline-divider" key={i + "price"}>
                  {"$" + range.node.price}
                </div>
              )
            )}
        </TableCell>
        <TableCell padding="dense">
          {item.min}
          {item.hasRange &&
            item.priceRanges.map(
              (range: *, i: number): * => (
                <div className="inline-divider" key={i + "minimun"}>
                  {"when >= " + range.node.minimumQuantity}
                </div>
              )
            )}
        </TableCell>
        <TableCell padding="dense">{item.max}</TableCell>
        <TableCell padding="dense">{item.desctiotion}</TableCell>
        <TableCell padding="dense">{item.notes}</TableCell>
        {this.props.canEdit && (
          <TableCell padding="dense">
            <IconButton
              aria-label="Edit"
              onClick={(): * => this.switchModalStatus(true)}
            >
              <EditIcon className="shine-icon" />
            </IconButton>
            <GeneralModalForm
              title={"Update " + item.partno}
              open={this.state.modalOpen}
              handleModalStatus={this.switchModalStatus}
              form={
                <UpdateProductPartForm
                  onClose={(): * => this.switchModalStatus(false)}
                  part={item}
                />
              }
            />
          </TableCell>
        )}
      </TableRow>
    );
  }
}

export default ProductSheetPartItem;
